import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  { path: 'cookies', redirectTo: '/cookie', pathMatch: 'full' },
  {
    path: 'om-oss',
    loadComponent: () =>
      import('./pages/about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'kontakt-oss',
    loadComponent: () =>
      import('./pages/contact/contact.component').then(
        (m) => m.ContactComponent,
      ),
  },
  {
    path: 'nyheter',
    loadComponent: () =>
      import('./pages/cases/cases.component').then((m) => m.CasesComponent),
  },
  {
    path: 'nyheter/:case',
    loadComponent: () =>
      import('./pages/case/case.component').then((m) => m.CaseComponent),
  },
  {
    path: 'baerekraft',
    loadComponent: () =>
      import('./pages/sustainability/sustainability.component').then(
        (m) => m.SustainabilityComponent,
      ),
  },
  {
    path: 'personvernerklaering',
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then(
        (m) => m.PrivacyComponent,
      ),
  },
  {
    path: 'cookie',
    loadComponent: () =>
      import('./pages/cookie/cookie.component').then((m) => m.CookieComponent),
  },
  {
    path: 'endre-registrering',
    loadComponent: () =>
      import(
        './pages/registration-edit-page/registration-edit-page.component'
      ).then((m) => m.RegistrationEditPageComponent),
  },
  {
    path: 'kundeside/presentasjoner-og-filer',
    loadComponent: () =>
      import('./pages/customer/presentation/presentation.component').then(
        (m) => m.PresentationComponent,
      ),
  },
  {
    path: 'kundeside/:url',
    loadComponent: () =>
      import('./pages/customer/customer.component').then(
        (m) => m.CustomerComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
  },
];
